const actions = {
  //error entering area/space
  async errorEnteringSpace({dispatch}) {
    dispatch('popups/show/error/custom', 'entering this Space', {root: true})
  },
  
  async confirmSwitchArea({rootGetters,dispatch}) {
    let loc = rootGetters['routing/routeName'] === 'area' ? 'Space' : 'Page'
    dispatch('popups/show/confirm',{
      message: `Are you sure you want <br> to leave this ${loc}? <br><br> You will be able to return to this ${loc}.`,
      buttons: [
        {
          name: 'Cancel',
          id: 'cancel',

          function: 'close'
        },
        {
          name: 'Leave',
          id: 'change-room',
          colour: 'red',

          function: async () => {
            await dispatch('analytics/leaveSpace', 'organic', {root: true})
            if(rootGetters['current_user/isExternalGuest']) dispatch('guest/space/returnToSpaceLobby', null, {root: true})
            else dispatch('routing/goToHome', null, {root: true})
          },
        }
      ]
    }, {root: true})
  },
  async confirmLeaveArea({dispatch}, callback) {
    dispatch('popups/show/confirm',{
      message: `Are you sure you want <br> to leave this Space?`,
      buttons: [
        {
          name: 'Cancel',
          id: 'cancel',

          function: 'close'
        },
        {
          name: 'Leave',
          id: 'change-room',
          colour: 'red',

          function: () => callback()
        }
      ]
    }, {root: true})
  },

  // AREA ERROR popups -----------------------------------------------------
  async errorLoadingUsersSpaces({dispatch}, callback) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: `There was an error loading your Spaces. <br></br> Please refresh to try again. <br></br> <small><i>If this error persists, please contact support at <u>support@spacein.co.uk</u></i></small>`,
      buttons: [
        {
          name: 'Refresh',
          id: 'refresh-spaces',
          colour: 'green',

          function: callback,
        }
      ]
    }, {root: true})
  },

  async errorCreatingArea({dispatch}) {
    dispatch('popups/show/error/creating', 'This Space', {root: true})
  },

  async errorRespondingToAreaInvite({dispatch}, {icon, message}) {
    dispatch('popups/show/confirm',{
      icon,
      message,
      buttons: [
        {
          name: 'Back To Spacein',
          id: 'accept-area-invite',
          colour: 'green',
          textColour: 'black',
          function: () => dispatch('routing/goToHome', null, {root: true})
        }
      ]
    }, {root: true})
  },
};

export default {
  actions
};
